export default "__VITE_ASSET__wLM$NvVi__"